import { ProgramCategory } from "@types";
import classNames from "classnames";
import { FC, useEffect, useRef } from "react";

interface Props {
  categories: ProgramCategory[];
  offsetTop: number;
  activeIndex: number | undefined;
  // eslint-disable-next-line no-unused-vars
  clickHandler: (categoryId: number) => void;
}

export const programLabelFormatter = (name: string) => {
  if (typeof name !== "string") return "";

  const forbidden = ["برنامه جامع یادگیری دروس تخصصی", "دروس تخصصی"];
  const usedForbiddenString = forbidden.find((str) =>
    name.startsWith(`${str} گرایش`)
  );

  if (!usedForbiddenString) return name;
  else return name.replace(usedForbiddenString, "");
};

const ProgramPageMobileNavigator: FC<Props> = ({
  categories,
  offsetTop,
  activeIndex,
  clickHandler,
}) => {
  const elementsRef = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    if (activeIndex === undefined) return;
    const theEl = elementsRef?.current?.[activeIndex];
    if (theEl)
      theEl.scrollIntoView({
        behavior: "instant" as ScrollBehavior,
        block: "nearest",
      });
  }, [activeIndex, categories]);

  const navigationHandler = (categoryId: number) => {
    const theEl = document.getElementById(`${categoryId}-programs`);
    clickHandler(categoryId);
    if (theEl)
      theEl.scrollIntoView({
        behavior: "smooth",
      });
  };

  return (
    <>
      <p className="lg:hidden title-md-medium text-fds-primary bg-fds-primary px-4     md:px-8">
        انتخاب دسته‌بندی یا گرایش
      </p>
      <div
        className="lg:hidden w-full z-30 sticky bg-fds-primary pb-2  pt-3"
        style={{ top: `${offsetTop}px` }}
      >
        <nav className="flex gap-2.5 hide-scrollbar overflow-x-auto pl-4 md:pl-8 mr-4 md:mr-8">
          {categories?.map((category, i) => {
            const isActive = i === activeIndex;
            return (
              <div
                key={i}
                className={classNames(
                  "px-2.5   rounded-8 flex items-center h-8   md:h-10",
                  isActive
                    ? "bg-fds-brand text-fds-on-brand"
                    : "bg-fds-secondary text-fds-primary"
                )}
                id={`category-navigator-${category.id}`}
                ref={(el) => {
                  el ? (elementsRef.current[i] = el) : undefined;
                }}
                onClick={() => navigationHandler(category.id)}
              >
                <p className="text-inherit body-sm md:body-md whitespace-nowrap cursor-pointer">
                  {programLabelFormatter(category.name)}
                </p>
              </div>
            );
          })}
        </nav>
      </div>
    </>
  );
};

export default ProgramPageMobileNavigator;
